var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLockOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16634 5.33333V5.83333H4.66634H3.99967C3.54248 5.83333 3.16634 6.20948 3.16634 6.66667V13.3333C3.16634 13.7905 3.54248 14.1667 3.99967 14.1667H11.9997C12.4569 14.1667 12.833 13.7905 12.833 13.3333V6.66667C12.833 6.20948 12.4569 5.83333 11.9997 5.83333H11.333H10.833V5.33333V4C10.833 2.43614 9.56353 1.16667 7.99967 1.16667C6.43582 1.16667 5.16634 2.43614 5.16634 4V5.33333ZM10.4997 5.33333V5.83333H9.99967H5.99967H5.49967V5.33333V4C5.49967 2.61719 6.61687 1.5 7.99967 1.5C9.38248 1.5 10.4997 2.61719 10.4997 4V5.33333ZM9.83301 10C9.83301 11.0095 9.00915 11.8333 7.99967 11.8333C6.9902 11.8333 6.16634 11.0095 6.16634 10C6.16634 8.99053 6.9902 8.16667 7.99967 8.16667C9.00915 8.16667 9.83301 8.99053 9.83301 10Z",
    fill: "#435869",
    stroke: "#435869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockOpera);
export default __webpack_public_path__ + "static/media/ic-lock-opera.449aafa4ed29191fa60c1881de013cfe.svg";
export { ForwardRef as ReactComponent };